// extracted by mini-css-extract-plugin
export default {"root":"ListingPrice_root__mfDip h3"};